/* ============================================================
   CTP Gallery / Lightbox engine
   Add as a theme asset and reference once in theme.liquid:
     {{ 'ctp-lightbox.js' | asset_url | script_tag }}
   Then any page only needs grid markup:
     <div class="ctp-grid ctp-grid--2col"> ...imgs... </div>
   ============================================================ */
(function () {
  if (window.__ctpGalleryInit) return;   // only ever set up once
  window.__ctpGalleryInit = true;

  function init() {
    // Build the lightbox overlay a single time and append to <body>
    var lb = document.createElement('div');
    lb.className = 'ctp-lightbox';
    lb.innerHTML =
      '<button class="ctp-lightbox-close" aria-label="Close">&times;</button>' +
      '<button class="ctp-lightbox-arrow ctp-lightbox-prev" aria-label="Previous">&#8249;</button>' +
      '<div class="ctp-lightbox-img-wrap"><img alt=""></div>' +
      '<button class="ctp-lightbox-arrow ctp-lightbox-next" aria-label="Next">&#8250;</button>' +
      '<div class="ctp-lightbox-counter"></div>';
    document.body.appendChild(lb);

    var lbImg    = lb.querySelector('.ctp-lightbox-img-wrap img');
    var closeBtn = lb.querySelector('.ctp-lightbox-close');
    var prevBtn  = lb.querySelector('.ctp-lightbox-prev');
    var nextBtn  = lb.querySelector('.ctp-lightbox-next');
    var counter  = lb.querySelector('.ctp-lightbox-counter');

    var group = [];      // images of the grid that was clicked
    var current = 0;

    function show(i) {
      current = (i + group.length) % group.length;
      lbImg.src = group[current].src;
      lbImg.alt = group[current].alt;
      counter.textContent = (current + 1) + ' / ' + group.length;
    }

    function openFrom(grid, clicked) {
      group = Array.prototype.slice.call(grid.querySelectorAll('img'));
      show(group.indexOf(clicked));
      lb.classList.add('ctp-open');
    }

    function close() {
      lb.classList.remove('ctp-open');
      lbImg.src = '';
      group = [];
    }

    // Event delegation: any image inside any .ctp-grid on the page,
    // including grids added further down, works automatically.
    document.addEventListener('click', function (e) {
      var img = e.target.closest && e.target.closest('.ctp-grid img');
      if (img) openFrom(img.closest('.ctp-grid'), img);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('ctp-lightbox-img-wrap')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('ctp-open')) return;
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowLeft')  show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================================
   CTP Slideshow  (crossfade + 4s autoplay)
   Append this to your ctp-lightbox.js theme asset (it lives
   happily alongside the gallery/lightbox engine — different
   class names and its own init guard, so no conflicts).

   Page markup only needs:
     <div class="ctp-slideshow">
       <img src="..." alt="...">
       ... more images ...
     </div>
   Arrows, counter, autoplay and swipe are built automatically.
   ============================================================ */
(function () {
  if (window.__ctpSlideshowInit) return;   // only ever set up once
  window.__ctpSlideshowInit = true;

  var AUTOPLAY_MS = 4000;
  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
    if (!imgs.length) return;

    var viewport = document.createElement('div');
    viewport.className = 'ctp-slideshow-viewport';

    var track = document.createElement('div');
    track.className = 'ctp-slideshow-track';

    var slides = imgs.map(function (img) {
      var slide = document.createElement('div');
      slide.className = 'ctp-slideshow-slide';
      slide.appendChild(img);          // moves the img into its slide
      track.appendChild(slide);
      return slide;
    });
    viewport.appendChild(track);

    var prev = document.createElement('button');
    prev.className = 'ctp-slideshow-arrow ctp-slideshow-prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = '&#8249;';

    var next = document.createElement('button');
    next.className = 'ctp-slideshow-arrow ctp-slideshow-next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = '&#8250;';

    viewport.appendChild(prev);
    viewport.appendChild(next);

    var counter = document.createElement('div');
    counter.className = 'ctp-slideshow-counter';
    viewport.appendChild(counter);

    root.innerHTML = '';
    root.appendChild(viewport);

    var current = 0;
    function render() {
      slides.forEach(function (s, i) {
        s.classList.toggle('ctp-active', i === current);
      });
      counter.textContent = (current + 1) + ' / ' + imgs.length;
    }
    function go(i) {
      current = (i + imgs.length) % imgs.length;
      render();
    }

    // autoplay
    var timer = null;
    function start() {
      if (reduceMotion || imgs.length < 2) return;
      stop();
      timer = setInterval(function () { go(current + 1); }, AUTOPLAY_MS);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    prev.addEventListener('click', function () { go(current - 1); restart(); });
    next.addEventListener('click', function () { go(current + 1); restart(); });

    if (imgs.length < 2) {
      prev.style.display = 'none';
      next.style.display = 'none';
      counter.style.display = 'none';
    }

    // pause while hovering
    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);

    // basic touch swipe (also pauses, then resumes)
    var startX = null;
    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (startX !== null) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx < 0 ? go(current + 1) : go(current - 1); }
        startX = null;
      }
      start();
    });

    render();
    start();
  }

  function init() {
    var nodes = document.querySelectorAll('.ctp-slideshow');
    Array.prototype.forEach.call(nodes, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();